import React from "react";
import CustomerHome from "../../../platform/pages/customer/home.jsx";
import SeoMeta from "../../../platform/components/common/seoMeta";

export default function CareBrowsePage(): JSX.Element {
  const canonicalUrl =
    typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search || ""}`
      : "/care/find";

  return (
    <>
      <SeoMeta
        title="Browse Care Homes | Plany365"
        description="Browse care homes, compare availability, and explore care options on Plany365."
        url={canonicalUrl}
      />
      <CustomerHome />
    </>
  );
}
